import React from 'react';
import { CheckIcon } from 'lucide-react';
import { included, trustLine, CTA_LABEL } from '../data/content';
import { Heading, Section } from './Primitives';
import { CheckoutButton } from './CheckoutButton';
import { Guarantee } from './Guarantee';
export function Pricing() {
  return <Section id="pricing" className="bg-cream" ariaLabel="Pricing" data-id="element-163" data-mp="2jjw7zccunmif">
      <div className="mx-auto max-w-xl text-center" data-id="element-164" data-mp="2jlpdgobq80ou">
        <Heading data-id="element-165" data-mp="1vta1hpihuaaj">One plan. Everything included.</Heading>
        <p className="mt-3 text-lg leading-relaxed text-ink-500" data-id="element-166" data-mp="1vvv1e8z8eg5n">
          Personalized guidance for your dog's everyday nutrition and care.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-2xl overflow-hidden rounded-3xl border border-orangey-100 bg-white shadow-card" data-id="element-167" data-mp="25tsouu99o8x7">
        <div className="border-b border-orangey-100 bg-orangey-50 px-6 py-7 text-center" data-id="element-168" data-mp="20v7lwn2mrb52">
          <p className="font-mono text-[0.65rem] font-semibold uppercase tracking-[0.16em] text-orangey-700" data-id="element-169" data-mp="3h9hdrr62zi0n">
            🐾 Pawsy Companion · main plan
          </p>
          <p className="mt-2 font-display text-6xl font-extrabold leading-none text-orangey-700" data-id="element-170" data-mp="3vyf7utymt42w">$29</p>
          <p className="mt-3 font-mono text-[0.68rem] font-semibold uppercase tracking-[0.14em] text-ink-500" data-id="element-171" data-mp="4ruideo8647z">
            {trustLine}
          </p>
        </div>

        <div className="px-6 py-7 sm:px-8" data-id="element-172" data-mp="er1uxzn4xuu1">
          <p className="font-mono text-[0.68rem] font-semibold uppercase tracking-[0.16em] text-orangey-700" data-id="element-173" data-mp="eqti27r0ipiu">
            What's included
          </p>
          <ul className="mt-4 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-174" data-mp="3i7sfrkndmcfs">
            {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-ink-700" data-id="element-175" data-mp="3n6lnsxjw9b8k">
                <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-safe/12" data-id="element-176" data-mp="3ry3mfeyg2zqd">
                  <CheckIcon className="h-3 w-3 text-safe" aria-hidden="true" data-id="element-177" data-mp="2uhekll9hvxgz" />
                </span>
                {item}
              </li>)}
          </ul>

          <p className="mt-5 rounded-xl border border-teal-500/25 bg-teal-50 px-4 py-3 text-sm leading-relaxed text-teal-700" data-id="element-178" data-mp="2rgcv1t0ym9u7">
            🍲 <strong className="font-semibold" data-id="element-179" data-mp="2mh0bpi9arkwd">Want homemade recipes too?</strong> Recipe Studio is available as a
            one-click add-on during checkout.
          </p>

          <CheckoutButton className="mt-6 w-full" data-id="element-180" data-mp="2w71pnh7xrmxk">{CTA_LABEL}</CheckoutButton>
          <Guarantee className="mt-3.5" data-id="element-181" data-mp="28i0ngbpp580q" />
          <p className="mt-3 text-center font-mono text-[0.65rem] font-semibold uppercase tracking-[0.12em] text-ink-400" data-id="element-182" data-mp="28is5skua9992">
            Instant access after purchase. Works on any device.
          </p>
        </div>
      </div>
    </Section>;
}